module.exports = __webpack_public_path__ + "img/Finnish.e3ef4011.svg";